/**
 * @generated SignedSource<<f1ffa93b0684c36c85529083687f99d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplacePersonalizedCarouselLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPersonalizationCarousel_viewer">;
  readonly " $fragmentType": "PdpRespMarketplacePersonalizedCarouselLazy_viewer";
};
export type PdpRespMarketplacePersonalizedCarouselLazy_viewer$key = {
  readonly " $data"?: PdpRespMarketplacePersonalizedCarouselLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplacePersonalizedCarouselLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplacePersonalizedCarouselLazy_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedPersonalizationCarousel_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c7560b2d7912608fab1881ffcf5a21b8";

export default node;
